import api from "@/api";

export default {
    namespaced: true,
    state: {
        locationData: {
            lat: 0,
            lng: 0,
            source: '',
            date: null,
            accuracy: 0,
            w3w: '',
        },
        questionInfo: {
            id: null,
            asset_id: '',
            placement: '',
            q_manage_screen_config: {},
            cro_asset_number: null,
            cro_asset_type: null,
        },
        newQuestionInfo: {
            asset_id: '',
            placement: '',
        },
    },
    getters: {
        getLocationData(state) {
            return state.locationData
        },
        hasQuestionInfo(state) {
            return state.questionInfo.id != null
        },
        getQuestionInfo(state) {
            return state.questionInfo
        },
        getNewQuestionInfo(state) {
            return state.newQuestionInfo
        }
    },
    mutations: {
        setLocationData(state, value) {
            if (value == null) {
                state.locationData = {
                    lat: 0,
                    lng: 0,
                    latCropped: '0',
                    lngCropped: '0',
                    source: '',
                    date: null,
                    accuracy: 0,
                    w3w: '',
                }
            } else {
                value.latCropped = Math.round(value.lat * 100000) / 100000 + '...'
                value.lngCropped = Math.round(value.lng * 100000) / 100000 + '...'
                state.locationData = value
            }
        },
        setW3W(state, value) {
            let old = Object.assign({}, state.locationData);
            old.w3w = value
            state.locationData = old
        },
        setQuestionInfo(state, value) {
            state.questionInfo = value
        },
        setQuestionInfoW3W(state, value) { //todo temp -> remove once get w3w from backend
            let old = Object.assign({}, state.questionInfo);
            if (old.location != null) {
                old.location.w3w = value
            }
            state.questionInfo = old
        },
        setAssetId(state, value) {
            state.newQuestionInfo.asset_id = value
        },
        setPlacement(state, value) {
            state.newQuestionInfo.placement = value
        },
    },
    actions: {
        async fetchQuestionInfo(context, questionId) {
            const url = `/api/v1/questions/${questionId}/info`
            const response = await api.request("get", url);
            context.commit("setQuestionInfo", response.data);
            return response.data;
        },

        async saveQuestionInfo(context, {body, questionUid}) {
            const url = `/api/v1/questions/${questionUid}/info`;
            return await api.request("put", url, body);
        },

        async changeQuestionPlacement(context, {body, questionUid}) {
            const url = `/api/v1/questions/${questionUid}/placement`;
            return await api.request("put", url, body);
        },

        async changeQuestionAssetId(context, {body, questionUid}) {
            const url = `/api/v1/questions/${questionUid}/asset_id`;
            return await api.request("put", url, body);
        },

        async saveQuestionGPS(context, {body, questionUid}) {
            const url = `/api/v1/questions/${questionUid}/gps`;
            return await api.request("put", url, body);
        },

        async searchJobById(context, {questionId, croJobId}) {
            const url = `/api/v1/questions/${questionId}/cro/job_search?cro_job_id=${croJobId}`
            const response = await api.request("get", url);
            return response.data;
        },

        async setJobIdForQuestion(context, {questionId, croJobId, updatePlacement, assetIsPortable}) {
            const url = `/api/v1/questions/${questionId}/cro/job?cro_job_id=${croJobId}&update_placement=${updatePlacement}&date_install_sensitive=${assetIsPortable}`
            const response = await api.request("put", url);
            return response.data;
        },

        async searchAssetByNumber(context, {questionId, assetNumber}) {
            const url = `/api/v1/questions/${questionId}/cro/asset-search?cro_asset_number=${assetNumber}`
            const response = await api.request("get", url);
            return response.data;
        },

        async setCROAssetNumberForQuestion(context, {questionId, assetNumber}) {
            const url = `/api/v1/questions/${questionId}/cro/asset?cro_asset_number=${assetNumber}`
            const response = await api.request("put", url);
            return response.data;
        },

        async setCROAssetTypeForQuestion(context, {questionId, assetTypeId, assetTypeName}) {
            const url = `/api/v1/questions/${questionId}/cro/asset-type?cro_asset_type_id=${assetTypeId}&cro_asset_type_name=${assetTypeName}`
            const response = await api.request("put", url);
            return response.data;
        },

        async clearPlacementInfo(context, {questionId}) {
            const url = `/api/v1/questions/${questionId}/placement-info`
            const response = await api.request("delete", url);
            return response.data;
        },
    }
}
